import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAssistantPanelStore = defineStore('assistantPanel', () => {
  const isOpen = ref(false)
  const panelWidth = 420

  return {
    isOpen,
    panelWidth
  }
})
